import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import IntroSection from './sections/IntroSection';
import AboutSection from './sections/AboutSection';
import InternshipSection from './sections/InternshipSection';
import ProjectsSection from './sections/ProjectsSection';
import ContactSection from './sections/ContactSection';
import Footer from './components/Footer';

function App() {
  const [darkMode, setDarkMode] = useState(true);
  const [activeSection, setActiveSection] = useState('intro');
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    // Default dark mode
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme === 'false') {
      setDarkMode(false);
      document.documentElement.classList.remove('dark');
    } else {
      setDarkMode(true);
      document.documentElement.classList.add('dark');
    }

    // Intersection Observer
    const observerOptions = {
      root: null,
      rootMargin: '-50% 0px -50% 0px',
      threshold: 0,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    const sections = document.querySelectorAll('section[id]');
    sections.forEach((section) => observer.observe(section));

    // Scroll listener for arrow visibility
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      sections.forEach((section) => observer.unobserve(section));
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleDarkMode = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    localStorage.setItem('darkMode', newDarkMode);

    if (newDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className="App relative">
      <Navbar 
        activeSection={activeSection} 
        darkMode={darkMode} 
        toggleDarkMode={toggleDarkMode} 
      />

      <IntroSection />
      <AboutSection />
      <InternshipSection />
      <ProjectsSection />
      <ContactSection />
      <Footer />

      {/* Scroll To Top Button */}
      {showScroll && (
  <div
    onClick={scrollToTop}
    className="fixed bottom-6 right-6 z-50 cursor-pointer"
  >
    <div
      className="
        relative w-11 h-11 flex items-center justify-center
        rounded-2xl
        border-2
        border-teal-700 dark:border-accent
        text-teal-700 dark:text-accent
        transition-all duration-300
        hover:bg-teal-700 hover:text-white
        dark:hover:bg-accent dark:hover:text-gray-900
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-5 h-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 15l7-7 7 7"
        />
      </svg>
    </div>
  </div>
)}

    </div>
  );
}

export default App;
